import { __rest, __assign } from 'tslib';
import React__default from 'react';

var combineProviders = function () {
    var providers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        providers[_i] = arguments[_i];
    }
    return providers.reduce(function (Providers, CurrentProvider) {
        return function (_a) {
            var children = _a.children, props = __rest(_a, ["children"]);
            return (React__default.createElement(Providers, __assign({}, props),
                React__default.createElement(CurrentProvider, __assign({}, props), children)));
        };
    }, function (_a) {
        var children = _a.children;
        return React__default.createElement(React__default.Fragment, null, children);
    });
};

export { combineProviders };
//# sourceMappingURL=combineProviders.esm.js.map
